/* eslint-disable import/no-unresolved */
import {
  ASTRO_PROFILE,
  GET_ASTRO_CHINESE_HOROSCOPE_PREDICTION,
  GET_ASTRO_FREE_KUNDLI_ASHTAKVARGA,
  GET_ASTRO_FREE_KUNDLI_BASIC,
  GET_ASTRO_FREE_KUNDLI_CHART,
  GET_ASTRO_FREE_KUNDLI_DASHA,
  GET_ASTRO_FREE_KUNDLI_KP,
  GET_ASTRO_FREE_KUNDLI_PLANETS,
  GET_ASTRO_FREE_KUNDLI_REPORT,
  GET_ASTRO_FREE_REPORT_GEMSTONES,
  GET_ASTRO_FREE_REPORT_KAALSARP_YOG,
  GET_ASTRO_FREE_REPORT_MANGLIK_REPORT,
  GET_ASTRO_FREE_REPORT_NUMEROLOGY,
  GET_ASTRO_FREE_REPORT_PITRA_DOSHA,
  GET_ASTRO_FREE_REPORT_POOJA,
  GET_ASTRO_FREE_REPORT_SADESATI_REPORT,
  GET_ASTRO_FREE_REPORT_VIMSHOTTARI_REPORT,
  GET_ASTRO_HOROSCOPE_PREDICTION,
  GET_ASTRO_KUNDLI_MATCH,
  GET_ASTRO_LAL_KITAB_HOUSES,
  GET_ASTRO_LAL_KITAB_PLANETS,
  GET_ASTRO_LOCATION,
  GET_ASTRO_MANGLIK_REPORT,
  GET_ASTRO_PANCHANG,
  GET_ASTRO_PANCHANG_CHOGHADIYA,
  GET_ASTRO_PANCHANG_HORA,
  GET_ASTRO_SUN_SIGN_PREDICTION,
  GET_ASTRO_TIMEZONE,
  GET_ASTRO_ZODIAC_COMPATIBILITY,
  GET_ASTRO_FREE_REPORT_PARTNER,
  GET_ASTRO_CALCULATOR_LOVE,
  GET_ASTRO_CALCULATOR_FRIENDSHIP,
  GET_ASTRO_FREE_REPORT_ANTAR_REPORT,
  GET_ASTRO_FREE_REPORT_PRATYANTAR_REPORT,
} from "../utils/apiEndPoints";
import {
  AstroDailyPanchangData,
  AstroDashaReport,
  AstroFreeKundliAshtakvargaResponse,
  AstroFreeKundliBasicResponse,
  AstroFreeKundliDashaResponse,
  AstroFreeKundliKpResponse,
  AstroFreeKundliPlanetResponse,
  AstroFreeKundliReportResponse,
  AstroHoroscopeResponse,
  AstroKundliMatchResponse,
  AstroManglikResponse,
  AstroPanchangChoghadiyaResponse,
  AstroPredictionReq,
  AstroSunSignResponse,
  AstroUserData,
  AstroUserDataReq,
  AstroUserDetailsReq,
  AstroVimshottariReport,
  ChineseHoroScopeReport,
  CommonResponse,
  DashaPeriodType,
  GemstoneReport,
  GeoLocationRes,
  ObjectType,
  PoojaReport,
  UserAstroProfile,
  ZodiacCompatibilityRes,
  ZodiacCompatibilityType,
} from "../modules/Astro/Enum";
import axiosInstance from "../utils/customAxios";
import { AstroPageData } from "@/types/common.types";

export const fetchTimeZone = async (countryCode: string, token: string) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_TIMEZONE,
      params: { countryCode, token },
    });

    return respData.data as { timezone: string };
  } catch (e) {
    console.log(e);
  }
};

export const fetchLocationData = async (place: string, token: string = "") => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_LOCATION,
      params: { place, token },
    });

    return respData.data as GeoLocationRes;
  } catch (e) {
    console.log(e);
  }
};

export const fetchSunSignPrediction = async (data: AstroPredictionReq) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_SUN_SIGN_PREDICTION,
      params: data,
    });

    return respData.data as AstroSunSignResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchHoroscopePrediction = async (data: AstroPredictionReq) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_HOROSCOPE_PREDICTION,
      params: data,
    });

    return respData.data as AstroHoroscopeResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPanchangData = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance({
      method: "GET",
      url: GET_ASTRO_PANCHANG,
      params: data,
    });

    return respData.data as AstroDailyPanchangData;
  } catch (e) {
    console.log(e);
  }
};

export const fetchKundliMatchDetails = async (
  data: AstroUserDataReq,
  token = ""
) => {
  try {
    const respData = await axiosInstance({
      method: "POST",
      url: GET_ASTRO_KUNDLI_MATCH,
      data,
      params: { token },
    });

    return respData.data as AstroKundliMatchResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchManglikReport = async (
  data: AstroUserDataReq,
  token = ""
) => {
  try {
    const respData = await axiosInstance({
      method: "POST",
      url: GET_ASTRO_MANGLIK_REPORT,
      data,
      params: { token },
    });

    return respData.data as AstroManglikResponse;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliBasicDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliBasicResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_BASIC,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliPlanetDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliPlanetResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_PLANETS,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliChartImage = async (
  chartId: string,
  chartType: string,
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<{ svg: string }>({
      method: "GET",
      url: `${GET_ASTRO_FREE_KUNDLI_CHART}/${chartId}`,
      params: { ...data, ChartType: chartType },
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliKpDetails = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliKpResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_KP,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliAshtakvargaDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliAshtakvargaResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_ASHTAKVARGA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliDashaDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliDashaResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_DASHA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFreeKundliReportDetails = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<AstroFreeKundliReportResponse>({
      method: "GET",
      url: GET_ASTRO_FREE_KUNDLI_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchKaalsarpYogReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_KAALSARP_YOG,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchManglikDoshaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_MANGLIK_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchPitraDoshaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_PITRA_DOSHA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchGemstonesReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<GemstoneReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_GEMSTONES,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchChineseHoroscopeReport = async (
  data: AstroUserDetailsReq
) => {
  try {
    const respData = await axiosInstance<ChineseHoroScopeReport>({
      method: "GET",
      url: GET_ASTRO_CHINESE_HOROSCOPE_PREDICTION,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchPoojaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<PoojaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_POOJA,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};
export const fetchSadesatiReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_SADESATI_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchVimshottariReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroVimshottariReport>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_VIMSHOTTARI_REPORT,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchAntarDashaReport = async (
  data: AstroUserDetailsReq,
  md: string
) => {
  try {
    const respData = await axiosInstance<DashaPeriodType[]>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_ANTAR_REPORT,
      params: { ...data, md },
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPratyantarDashaReport = async (
  data: AstroUserDetailsReq,
  md: string,
  ad: string
) => {
  try {
    const respData = await axiosInstance<DashaPeriodType[]>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_PRATYANTAR_REPORT,
      params: { ...data, md, ad },
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchNumerologyReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<AstroPageData[]>({
      method: "GET",
      url: GET_ASTRO_FREE_REPORT_NUMEROLOGY,
      params: data,
    });

    return respData.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchHoraReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<{
      hora: AstroPanchangChoghadiyaResponse;
    }>({
      method: "GET",
      url: GET_ASTRO_PANCHANG_HORA,
      params: data,
    });

    return respData?.data?.hora;
  } catch (e) {
    console.log(e);
  }
};

export const fetchChoghadiyaReport = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<{
      chaughadiya: AstroPanchangChoghadiyaResponse;
    }>({
      method: "GET",
      url: GET_ASTRO_PANCHANG_CHOGHADIYA,
      params: data,
    });

    return respData?.data?.chaughadiya;
  } catch (e) {
    console.log(e);
  }
};

export const fetchPartnerReport = async (data: {
  maleData: AstroUserDetailsReq;
  femaleData: AstroUserDetailsReq;
}) => {
  try {
    const respData = await axiosInstance<AstroDashaReport>({
      method: "POST",
      url: GET_ASTRO_FREE_REPORT_PARTNER,
      data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchLoveCalulatorReport = async (data: {
  maleData: AstroUserDetailsReq;
  femaleData: AstroUserDetailsReq;
}) => {
  try {
    const respData = await axiosInstance<{ love_report: string[] }>({
      method: "POST",
      url: GET_ASTRO_CALCULATOR_LOVE,
      data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchFriendshipReport = async (data: {
  maleData: AstroUserDetailsReq;
  femaleData: AstroUserDetailsReq;
}) => {
  try {
    const respData = await axiosInstance<{ friendship_report: string[] }>({
      method: "POST",
      url: GET_ASTRO_CALCULATOR_FRIENDSHIP,
      data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchZodiacCompatibility = async (
  data: ZodiacCompatibilityType
) => {
  try {
    const respData = await axiosInstance<ZodiacCompatibilityRes>({
      method: "GET",
      url: GET_ASTRO_ZODIAC_COMPATIBILITY,
      params: data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchLalKitabHouses = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<ObjectType[]>({
      method: "GET",
      url: GET_ASTRO_LAL_KITAB_HOUSES,
      params: data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchLalKitabPlanets = async (data: AstroUserDetailsReq) => {
  try {
    const respData = await axiosInstance<ObjectType[]>({
      method: "GET",
      url: GET_ASTRO_LAL_KITAB_PLANETS,
      params: data,
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const fetchAstroProfiles = async (token: string = "") => {
  try {
    const respData = await axiosInstance<CommonResponse<UserAstroProfile[]>>({
      method: "GET",
      url: ASTRO_PROFILE,
      params: { token },
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const addAstroProfiles = async (reqBody: AstroUserData, token = "") => {
  try {
    console.log(token);
    const respData = await axiosInstance<CommonResponse<{}>>({
      method: "POST",
      url: ASTRO_PROFILE,
      params: { token },
      data: {
        firstName: reqBody?.name,
        dob: reqBody?.dob,
        tob: reqBody?.tob,
        pob: reqBody?.pob,
        gender: reqBody?.gender,
      },
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};

export const deleteAstroProfile = async (id: number, token: string = "") => {
  try {
    const respData = await axiosInstance<CommonResponse<{}>>({
      method: "DELETE",
      url: ASTRO_PROFILE,
      params: {
        id: JSON.stringify(id),
        token,
      },
    });

    return respData?.data;
  } catch (e) {
    console.log(e);
  }
};
